'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactElement, useState } from 'react';
interface HoverIconProps {
  defaultIcon: ReactElement<any>;
  hoverIcon: ReactElement<any>;
}
function HoverIcon(t0) {
  const $ = _c(4);
  const {
    defaultIcon,
    hoverIcon
  } = t0;
  const [isHovered, setIsHovered] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setIsHovered(true);
    t2 = () => setIsHovered(false);
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  const t3 = isHovered ? hoverIcon : defaultIcon;
  let t4;
  if ($[2] !== t3) {
    t4 = <div onMouseEnter={t1} onMouseLeave={t2}>{t3}</div>;
    $[2] = t3;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
}
export default HoverIcon;